import { Button, Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import LoadingScreen from "src/components/LoadingScreen";
import useSettings from "src/hooks/useSettings";
import { PATH_DASHBOARD } from "src/routes/paths";
import { getSyncConfigDataApi } from "src/Api/Services/SystemConfiguration";
import SyncConfigTable from "./SyncConfigTable";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
import UpdateSyncConfig from "./UpdateSyncConfig";

const SyncConfig = () => {
  const { themeStretch } = useSettings();
  const [syncConfigData, setSyncConfigData] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState("");
  const [loading, setloading] = useState(true);
  const fetchData = async () => {
    try {
      const { data } = await getSyncConfigDataApi();
      let newRes = data.data.length > 0 ? data.data : [];
      setSyncConfigData(newRes || []);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
      <HeaderBreadcrumbs
        heading="Sync Config"
        links={[
          { name: "Dashboard", href: PATH_DASHBOARD.root },
          {
            name: "Add Sync Config",
            href: PATH_DASHBOARD.systemConfig.syncConfig,
          },
        ]}
      />
      <div className="text-right">
        {syncConfigData.length > 0 && (
          <SyncConfigTable
            data={syncConfigData}
            editClick={(item) => setEditData(item)}
          />
        )}
      </div>
      <CustomModalComp
        show={editData ? true : false}
        onHide={() => setEditData("")}
        title="Update Sync Config"
        backdrop={true}
      >
        <UpdateSyncConfig
          data={editData}
          fetchData={() => {
            fetchData();
            setEditData("");
          }}
        />
      </CustomModalComp>
    </Container>
  );
};

export default SyncConfig;
